// src/portal-app/shell/kit/SegmentedControl.js
//
// iOS-style sibling-view toggle (radio-group a11y). Cross-cutting by
// definition (spec §6) — moved here from operations/kit.js (Plan 4 Task 1)
// so Team/More screens no longer reach into an Operations module for it.
// Class names (.opk-*) kept byte-identical; rules moved into kitCss.js.
//
// Radio-group semantics: role="radiogroup" on container, role="radio" +
// aria-checked on each option. ≥44pt touch targets.
import React from 'react';
import { ensureKitCss } from './kitCss';

// props:
//   options   [{id, label}]
//   value     string — active option id
//   onChange  (id) => void
export function SegmentedControl({ options = [], value, onChange }) {
    ensureKitCss();
    return (
        <div className="opk-seg" role="radiogroup">
            {options.map((opt) => {
                const key = opt.value ?? opt.id;
                const active = key === value;
                return (
                    <button
                        key={key}
                        type="button"
                        role="radio"
                        aria-checked={active}
                        className={`opk-seg-opt${active ? ' opk-seg-active' : ''}`}
                        onClick={() => { if (!active) onChange(key); }}
                    >
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
}

export default SegmentedControl;
